import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { toast } from "react-toastify";
import { v4 as uid } from "uuid";
import * as Yup from "yup";
import { loggerService, networkService } from "../../services";
import { useSidebarStore } from "../../store";
import { Header } from "../shared/components";
import FieldError from "../shared/components/field-error.component";
import { useServiceProvider } from "../shared/hooks";

const waitingRoomSchema = Yup.object().shape({
  orgName: Yup.string().required("Please enter organization name"),
  greetings: Yup.string().required("Please enter greetings text"),
  about: Yup.string().required("Please enter About text"),
  link: Yup.string(),
});

const URL = `${process.env.REACT_APP_OPEN_TELE_URL}api/rooms/waiting-room-config`;

const WaitingRoom: React.FC = () => {
  const [displayVals, setDisplayVals] = useState({
    orgName: "",
    greetings: "",
    about: "",
    allLinks: [],
    images: [],
  });
  const toggleSidebar = useSidebarStore((state) => state.toggleSidebar);

  const {
    organization: { id: orgId },
    firstName,
  } = useServiceProvider();

  const handleSubmit = async (values) => {
    const finalVals = { ...values };
    delete finalVals.link;
    setDisplayVals({ ...finalVals });

    const reqLinks = [];
    values.allLinks.map(({ href }) => {
      return reqLinks.push(href);
    });

    const reqGallery = [];
    values.images.map(({ name, src }) => {
      const newSrc = src.split(",")[1];
      return reqGallery.push({ name, resource: newSrc });
    });

    const bodyObject = {
      organizationId: orgId,
      aboutMe: values.about,
      greeting: values.greetings,
      importantLinks: [...reqLinks],
      displayWaitingConsumers: false,
      gallery: reqGallery,
    };

    try {
      await networkService.post(URL, bodyObject);
    } catch (error) {
      loggerService.error(error.message);
    }
  };

  async function readFileAsText(file) {
    const promise = new Promise(function (resolve, reject) {
      const fr = new FileReader();

      fr.onload = function () {
        resolve(fr.result);
      };

      fr.onerror = function () {
        reject(fr);
      };

      fr.readAsDataURL(file);
    });
    return await promise;
  }

  const encodeFile = (element, setFieldValue, values) => {
    const files = element.target.files;
    const totalFileLength = Number(values.images.length) + Number(files.length);

    if (totalFileLength > 5) {
      toast.error("Maximum 5 files allowed.");
      return;
    }
    const readers = [];

    for (let i = 0; i < files.length; i++) {
      const fileSizeInMb = Number((files[i].size / 1024 / 1024).toFixed(3));
      if (fileSizeInMb > 10) {
        toast.error("Maximum file size allowed - 10mb");
        continue;
      }

      readers.push(readFileAsText(files[i]));
    }

    Promise.all(readers).then((value) => {
      const newImages = value.map((item, index) => {
        return { id: uid(), name: files[index].name, src: item };
      });

      setFieldValue("images", [...values.images, ...newImages]);
    });
  };

  const removeImage = (imgId, values, setFieldValue) => {
    const newImages = values.images.filter(({ id }) => id !== imgId);

    setFieldValue("images", [...newImages]);
  };

  const handleAddLinks = (values, setFieldValue) => {
    const newLink = values.link;
    const urlRegex =
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    if (!newLink || !urlRegex.test(newLink)) {
      return;
    }
    const newLinks = [...values.allLinks, { id: uid(), href: values.link }];
    setFieldValue("allLinks", newLinks);
    setFieldValue("link", "");
  };

  return (
    <div>
      {/* <nav className="bg-white grid grid-cols-2 py-3 px-4 items-center">
        <p>Manage Waiting room</p>
        <form className="flex justify-end gap-x-3">
          <input
            type="email"
            placeholder="Email id"
            className="rounded-md w-64"
          />
          <button className="bg-primary p-3 rounded-md grid place-items-center">
            <svg
              width="125"
              height="15"
              viewBox="0 0 125 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.289648 7.31V5.975H3.12465V3.32H4.50465V5.975H7.33965V7.31H4.50465V9.98H3.12465V7.31H0.289648ZM13.0816 11V0.499999H14.6716V11H13.0816ZM16.7423 11V3.56H18.1523L18.2723 4.865C18.5023 4.405 18.8373 4.045 19.2773 3.785C19.7273 3.515 20.2423 3.38 20.8223 3.38C21.7223 3.38 22.4273 3.66 22.9373 4.22C23.4573 4.78 23.7173 5.615 23.7173 6.725V11H22.1423V6.89C22.1423 5.45 21.5523 4.73 20.3723 4.73C19.7823 4.73 19.2923 4.94 18.9023 5.36C18.5223 5.78 18.3323 6.38 18.3323 7.16V11H16.7423ZM27.5578 11L24.7678 3.56H26.4328L28.5028 9.485L30.5728 3.56H32.2228L29.4478 11H27.5578ZM34.4294 2.15C34.1294 2.15 33.8794 2.06 33.6794 1.88C33.4894 1.69 33.3944 1.455 33.3944 1.175C33.3944 0.895 33.4894 0.665 33.6794 0.484999C33.8794 0.295 34.1294 0.2 34.4294 0.2C34.7294 0.2 34.9744 0.295 35.1644 0.484999C35.3644 0.665 35.4644 0.895 35.4644 1.175C35.4644 1.455 35.3644 1.69 35.1644 1.88C34.9744 2.06 34.7294 2.15 34.4294 2.15ZM33.6344 11V3.56H35.2244V11H33.6344ZM40.4434 11C39.7134 11 39.1334 10.825 38.7034 10.475C38.2734 10.115 38.0584 9.48 38.0584 8.57V4.895H36.7834V3.56H38.0584L38.2534 1.67H39.6484V3.56H41.7484V4.895H39.6484V8.57C39.6484 8.98 39.7334 9.265 39.9034 9.425C40.0834 9.575 40.3884 9.65 40.8184 9.65H41.6734V11H40.4434ZM46.6774 11.18C45.9474 11.18 45.2974 11.02 44.7274 10.7C44.1674 10.37 43.7274 9.915 43.4074 9.335C43.0874 8.755 42.9274 8.08 42.9274 7.31C42.9274 6.53 43.0824 5.845 43.3924 5.255C43.7124 4.665 44.1524 4.205 44.7124 3.875C45.2824 3.545 45.9424 3.38 46.6924 3.38C47.4224 3.38 48.0574 3.545 48.5974 3.875C49.1374 4.195 49.5574 4.625 49.8574 5.165C50.1574 5.705 50.3074 6.3 50.3074 6.95C50.3074 7.05 50.3024 7.16 50.2924 7.28C50.2924 7.39 50.2874 7.515 50.2774 7.655H44.4874C44.5374 8.375 44.7724 8.925 45.1924 9.305C45.6224 9.675 46.1174 9.86 46.6774 9.86C47.1274 9.86 47.5024 9.76 47.8024 9.56C48.1124 9.35 48.3424 9.07 48.4924 8.72H50.0824C49.8824 9.42 49.4824 10.005 48.8824 10.475C48.2924 10.945 47.5574 11.18 46.6774 11.18ZM46.6774 4.685C46.1474 4.685 45.6774 4.845 45.2674 5.165C44.8574 5.475 44.6074 5.945 44.5174 6.575H48.7174C48.6874 5.995 48.4824 5.535 48.1024 5.195C47.7224 4.855 47.2474 4.685 46.6774 4.685ZM60.4764 11.18C59.4364 11.18 58.5364 10.955 57.7764 10.505C57.0264 10.045 56.4464 9.41 56.0364 8.6C55.6264 7.78 55.4214 6.835 55.4214 5.765C55.4214 4.685 55.6264 3.74 56.0364 2.93C56.4464 2.11 57.0264 1.47 57.7764 1.01C58.5364 0.55 59.4364 0.32 60.4764 0.32C61.7064 0.32 62.7114 0.62 63.4914 1.22C64.2714 1.82 64.7664 2.66 64.9764 3.74H63.2064C63.0664 3.13 62.7664 2.645 62.3064 2.285C61.8464 1.925 61.2314 1.745 60.4614 1.745C59.4114 1.745 58.5814 2.105 57.9714 2.825C57.3614 3.535 57.0564 4.515 57.0564 5.765C57.0564 7.005 57.3614 7.98 57.9714 8.69C58.5814 9.4 59.4114 9.755 60.4614 9.755C61.2314 9.755 61.8464 9.585 62.3064 9.245C62.7664 8.905 63.0664 8.44 63.2064 7.85H64.9764C64.7664 8.89 64.2714 9.705 63.4914 10.295C62.7114 10.885 61.7064 11.18 60.4764 11.18ZM70.1442 11.18C69.4342 11.18 68.7942 11.02 68.2242 10.7C67.6642 10.37 67.2192 9.915 66.8892 9.335C66.5592 8.745 66.3942 8.06 66.3942 7.28C66.3942 6.5 66.5592 5.82 66.8892 5.24C67.2292 4.65 67.6842 4.195 68.2542 3.875C68.8242 3.545 69.4592 3.38 70.1592 3.38C70.8692 3.38 71.5042 3.545 72.0642 3.875C72.6342 4.195 73.0842 4.65 73.4142 5.24C73.7542 5.82 73.9242 6.5 73.9242 7.28C73.9242 8.06 73.7542 8.745 73.4142 9.335C73.0842 9.915 72.6342 10.37 72.0642 10.7C71.4942 11.02 70.8542 11.18 70.1442 11.18ZM70.1442 9.815C70.5242 9.815 70.8742 9.72 71.1942 9.53C71.5242 9.34 71.7892 9.06 71.9892 8.69C72.1892 8.31 72.2892 7.84 72.2892 7.28C72.2892 6.72 72.1892 6.255 71.9892 5.885C71.7992 5.505 71.5392 5.22 71.2092 5.03C70.8892 4.84 70.5392 4.745 70.1592 4.745C69.7792 4.745 69.4242 4.84 69.0942 5.03C68.7742 5.22 68.5142 5.505 68.3142 5.885C68.1142 6.255 68.0142 6.72 68.0142 7.28C68.0142 7.84 68.1142 8.31 68.3142 8.69C68.5142 9.06 68.7742 9.34 69.0942 9.53C69.4142 9.72 69.7642 9.815 70.1442 9.815ZM75.6437 11V0.2H77.2337V11H75.6437ZM79.2472 11V0.2H80.8372V11H79.2472ZM86.3307 11.18C85.6007 11.18 84.9507 11.02 84.3807 10.7C83.8207 10.37 83.3807 9.915 83.0607 9.335C82.7407 8.755 82.5807 8.08 82.5807 7.31C82.5807 6.53 82.7357 5.845 83.0457 5.255C83.3657 4.665 83.8057 4.205 84.3657 3.875C84.9357 3.545 85.5957 3.38 86.3457 3.38C87.0757 3.38 87.7107 3.545 88.2507 3.875C88.7907 4.195 89.2107 4.625 89.5107 5.165C89.8107 5.705 89.9607 6.3 89.9607 6.95C89.9607 7.05 89.9557 7.16 89.9457 7.28C89.9457 7.39 89.9407 7.515 89.9307 7.655H84.1407C84.1907 8.375 84.4257 8.925 84.8457 9.305C85.2757 9.675 85.7707 9.86 86.3307 9.86C86.7807 9.86 87.1557 9.76 87.4557 9.56C87.7657 9.35 87.9957 9.07 88.1457 8.72H89.7357C89.5357 9.42 89.1357 10.005 88.5357 10.475C87.9457 10.945 87.2107 11.18 86.3307 11.18ZM86.3307 4.685C85.8007 4.685 85.3307 4.845 84.9207 5.165C84.5107 5.475 84.2607 5.945 84.1707 6.575H88.3707C88.3407 5.995 88.1357 5.535 87.7557 5.195C87.3757 4.855 86.9007 4.685 86.3307 4.685ZM94.1305 11.18C93.5005 11.18 92.9805 11.075 92.5705 10.865C92.1605 10.655 91.8555 10.38 91.6555 10.04C91.4555 9.69 91.3555 9.31 91.3555 8.9C91.3555 8.18 91.6355 7.61 92.1955 7.19C92.7555 6.77 93.5555 6.56 94.5955 6.56H96.5455V6.425C96.5455 5.845 96.3855 5.41 96.0655 5.12C95.7555 4.83 95.3505 4.685 94.8505 4.685C94.4105 4.685 94.0255 4.795 93.6955 5.015C93.3755 5.225 93.1805 5.54 93.1105 5.96H91.5205C91.5705 5.42 91.7505 4.96 92.0605 4.58C92.3805 4.19 92.7805 3.895 93.2605 3.695C93.7505 3.485 94.2855 3.38 94.8655 3.38C95.9055 3.38 96.7105 3.655 97.2805 4.205C97.8505 4.745 98.1355 5.485 98.1355 6.425V11H96.7555L96.6205 9.725C96.4105 10.135 96.1055 10.48 95.7055 10.76C95.3055 11.04 94.7805 11.18 94.1305 11.18ZM94.4455 9.89C94.8755 9.89 95.2355 9.79 95.5255 9.59C95.8255 9.38 96.0555 9.105 96.2155 8.765C96.3855 8.425 96.4905 8.05 96.5305 7.64H94.7605C94.1305 7.64 93.6805 7.75 93.4105 7.97C93.1505 8.19 93.0205 8.465 93.0205 8.795C93.0205 9.135 93.1455 9.405 93.3955 9.605C93.6555 9.795 94.0055 9.89 94.4455 9.89ZM103.034 8.72C102.644 8.72 102.284 8.675 101.954 8.585L101.309 9.215C101.419 9.285 101.554 9.345 101.714 9.395C101.874 9.445 102.099 9.49 102.389 9.53C102.679 9.57 103.074 9.61 103.574 9.65C104.564 9.74 105.279 9.98 105.719 10.37C106.159 10.75 106.379 11.26 106.379 11.9C106.379 12.34 106.259 12.755 106.019 13.145C105.789 13.545 105.424 13.865 104.924 14.105C104.434 14.355 103.804 14.48 103.034 14.48C101.994 14.48 101.149 14.28 100.499 13.88C99.8594 13.49 99.5394 12.895 99.5394 12.095C99.5394 11.785 99.6194 11.475 99.7794 11.165C99.9494 10.865 100.214 10.58 100.574 10.31C100.364 10.22 100.179 10.125 100.019 10.025C99.8694 9.915 99.7344 9.805 99.6144 9.695V9.335L100.904 8.015C100.324 7.515 100.034 6.86 100.034 6.05C100.034 5.56 100.149 5.115 100.379 4.715C100.619 4.305 100.964 3.98 101.414 3.74C101.864 3.5 102.404 3.38 103.034 3.38C103.454 3.38 103.844 3.44 104.204 3.56H106.979V4.61L105.659 4.685C105.899 5.095 106.019 5.55 106.019 6.05C106.019 6.55 105.899 7 105.659 7.4C105.429 7.8 105.089 8.12 104.639 8.36C104.199 8.6 103.664 8.72 103.034 8.72ZM103.034 7.475C103.494 7.475 103.864 7.355 104.144 7.115C104.434 6.865 104.579 6.515 104.579 6.065C104.579 5.605 104.434 5.255 104.144 5.015C103.864 4.775 103.494 4.655 103.034 4.655C102.564 4.655 102.184 4.775 101.894 5.015C101.614 5.255 101.474 5.605 101.474 6.065C101.474 6.515 101.614 6.865 101.894 7.115C102.184 7.355 102.564 7.475 103.034 7.475ZM101.039 11.945C101.039 12.375 101.229 12.695 101.609 12.905C101.989 13.125 102.464 13.235 103.034 13.235C103.584 13.235 104.029 13.115 104.369 12.875C104.709 12.645 104.879 12.335 104.879 11.945C104.879 11.655 104.764 11.405 104.534 11.195C104.304 10.995 103.869 10.87 103.229 10.82C102.749 10.79 102.324 10.745 101.954 10.685C101.604 10.875 101.364 11.08 101.234 11.3C101.104 11.52 101.039 11.735 101.039 11.945ZM111.143 11.18C110.243 11.18 109.533 10.9 109.013 10.34C108.503 9.78 108.248 8.945 108.248 7.835V3.56H109.838V7.67C109.838 9.11 110.428 9.83 111.608 9.83C112.198 9.83 112.683 9.62 113.063 9.2C113.443 8.78 113.633 8.18 113.633 7.4V3.56H115.223V11H113.813L113.693 9.695C113.463 10.155 113.123 10.52 112.673 10.79C112.233 11.05 111.723 11.18 111.143 11.18ZM120.725 11.18C119.995 11.18 119.345 11.02 118.775 10.7C118.215 10.37 117.775 9.915 117.455 9.335C117.135 8.755 116.975 8.08 116.975 7.31C116.975 6.53 117.13 5.845 117.44 5.255C117.76 4.665 118.2 4.205 118.76 3.875C119.33 3.545 119.99 3.38 120.74 3.38C121.47 3.38 122.105 3.545 122.645 3.875C123.185 4.195 123.605 4.625 123.905 5.165C124.205 5.705 124.355 6.3 124.355 6.95C124.355 7.05 124.35 7.16 124.34 7.28C124.34 7.39 124.335 7.515 124.325 7.655H118.535C118.585 8.375 118.82 8.925 119.24 9.305C119.67 9.675 120.165 9.86 120.725 9.86C121.175 9.86 121.55 9.76 121.85 9.56C122.16 9.35 122.39 9.07 122.54 8.72H124.13C123.93 9.42 123.53 10.005 122.93 10.475C122.34 10.945 121.605 11.18 120.725 11.18ZM120.725 4.685C120.195 4.685 119.725 4.845 119.315 5.165C118.905 5.475 118.655 5.945 118.565 6.575H122.765C122.735 5.995 122.53 5.535 122.15 5.195C121.77 4.855 121.295 4.685 120.725 4.685Z"
                fill="white"
              />
            </svg>
          </button>
        </form>
      </nav> */}
      <Header title="Manage waiting room" setSidebarOpen={toggleSidebar}>
        <div>
          <form className="flex justify-end gap-x-3">
            <input
              type="email"
              placeholder="Email id"
              className="rounded-sm w-64 borde-1 border-grey-secondary"
            />
            <button className="bg-primary p-3 rounded-md grid place-items-center">
              <svg
                width="125"
                height="15"
                viewBox="0 0 125 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.289648 7.31V5.975H3.12465V3.32H4.50465V5.975H7.33965V7.31H4.50465V9.98H3.12465V7.31H0.289648ZM13.0816 11V0.499999H14.6716V11H13.0816ZM16.7423 11V3.56H18.1523L18.2723 4.865C18.5023 4.405 18.8373 4.045 19.2773 3.785C19.7273 3.515 20.2423 3.38 20.8223 3.38C21.7223 3.38 22.4273 3.66 22.9373 4.22C23.4573 4.78 23.7173 5.615 23.7173 6.725V11H22.1423V6.89C22.1423 5.45 21.5523 4.73 20.3723 4.73C19.7823 4.73 19.2923 4.94 18.9023 5.36C18.5223 5.78 18.3323 6.38 18.3323 7.16V11H16.7423ZM27.5578 11L24.7678 3.56H26.4328L28.5028 9.485L30.5728 3.56H32.2228L29.4478 11H27.5578ZM34.4294 2.15C34.1294 2.15 33.8794 2.06 33.6794 1.88C33.4894 1.69 33.3944 1.455 33.3944 1.175C33.3944 0.895 33.4894 0.665 33.6794 0.484999C33.8794 0.295 34.1294 0.2 34.4294 0.2C34.7294 0.2 34.9744 0.295 35.1644 0.484999C35.3644 0.665 35.4644 0.895 35.4644 1.175C35.4644 1.455 35.3644 1.69 35.1644 1.88C34.9744 2.06 34.7294 2.15 34.4294 2.15ZM33.6344 11V3.56H35.2244V11H33.6344ZM40.4434 11C39.7134 11 39.1334 10.825 38.7034 10.475C38.2734 10.115 38.0584 9.48 38.0584 8.57V4.895H36.7834V3.56H38.0584L38.2534 1.67H39.6484V3.56H41.7484V4.895H39.6484V8.57C39.6484 8.98 39.7334 9.265 39.9034 9.425C40.0834 9.575 40.3884 9.65 40.8184 9.65H41.6734V11H40.4434ZM46.6774 11.18C45.9474 11.18 45.2974 11.02 44.7274 10.7C44.1674 10.37 43.7274 9.915 43.4074 9.335C43.0874 8.755 42.9274 8.08 42.9274 7.31C42.9274 6.53 43.0824 5.845 43.3924 5.255C43.7124 4.665 44.1524 4.205 44.7124 3.875C45.2824 3.545 45.9424 3.38 46.6924 3.38C47.4224 3.38 48.0574 3.545 48.5974 3.875C49.1374 4.195 49.5574 4.625 49.8574 5.165C50.1574 5.705 50.3074 6.3 50.3074 6.95C50.3074 7.05 50.3024 7.16 50.2924 7.28C50.2924 7.39 50.2874 7.515 50.2774 7.655H44.4874C44.5374 8.375 44.7724 8.925 45.1924 9.305C45.6224 9.675 46.1174 9.86 46.6774 9.86C47.1274 9.86 47.5024 9.76 47.8024 9.56C48.1124 9.35 48.3424 9.07 48.4924 8.72H50.0824C49.8824 9.42 49.4824 10.005 48.8824 10.475C48.2924 10.945 47.5574 11.18 46.6774 11.18ZM46.6774 4.685C46.1474 4.685 45.6774 4.845 45.2674 5.165C44.8574 5.475 44.6074 5.945 44.5174 6.575H48.7174C48.6874 5.995 48.4824 5.535 48.1024 5.195C47.7224 4.855 47.2474 4.685 46.6774 4.685ZM60.4764 11.18C59.4364 11.18 58.5364 10.955 57.7764 10.505C57.0264 10.045 56.4464 9.41 56.0364 8.6C55.6264 7.78 55.4214 6.835 55.4214 5.765C55.4214 4.685 55.6264 3.74 56.0364 2.93C56.4464 2.11 57.0264 1.47 57.7764 1.01C58.5364 0.55 59.4364 0.32 60.4764 0.32C61.7064 0.32 62.7114 0.62 63.4914 1.22C64.2714 1.82 64.7664 2.66 64.9764 3.74H63.2064C63.0664 3.13 62.7664 2.645 62.3064 2.285C61.8464 1.925 61.2314 1.745 60.4614 1.745C59.4114 1.745 58.5814 2.105 57.9714 2.825C57.3614 3.535 57.0564 4.515 57.0564 5.765C57.0564 7.005 57.3614 7.98 57.9714 8.69C58.5814 9.4 59.4114 9.755 60.4614 9.755C61.2314 9.755 61.8464 9.585 62.3064 9.245C62.7664 8.905 63.0664 8.44 63.2064 7.85H64.9764C64.7664 8.89 64.2714 9.705 63.4914 10.295C62.7114 10.885 61.7064 11.18 60.4764 11.18ZM70.1442 11.18C69.4342 11.18 68.7942 11.02 68.2242 10.7C67.6642 10.37 67.2192 9.915 66.8892 9.335C66.5592 8.745 66.3942 8.06 66.3942 7.28C66.3942 6.5 66.5592 5.82 66.8892 5.24C67.2292 4.65 67.6842 4.195 68.2542 3.875C68.8242 3.545 69.4592 3.38 70.1592 3.38C70.8692 3.38 71.5042 3.545 72.0642 3.875C72.6342 4.195 73.0842 4.65 73.4142 5.24C73.7542 5.82 73.9242 6.5 73.9242 7.28C73.9242 8.06 73.7542 8.745 73.4142 9.335C73.0842 9.915 72.6342 10.37 72.0642 10.7C71.4942 11.02 70.8542 11.18 70.1442 11.18ZM70.1442 9.815C70.5242 9.815 70.8742 9.72 71.1942 9.53C71.5242 9.34 71.7892 9.06 71.9892 8.69C72.1892 8.31 72.2892 7.84 72.2892 7.28C72.2892 6.72 72.1892 6.255 71.9892 5.885C71.7992 5.505 71.5392 5.22 71.2092 5.03C70.8892 4.84 70.5392 4.745 70.1592 4.745C69.7792 4.745 69.4242 4.84 69.0942 5.03C68.7742 5.22 68.5142 5.505 68.3142 5.885C68.1142 6.255 68.0142 6.72 68.0142 7.28C68.0142 7.84 68.1142 8.31 68.3142 8.69C68.5142 9.06 68.7742 9.34 69.0942 9.53C69.4142 9.72 69.7642 9.815 70.1442 9.815ZM75.6437 11V0.2H77.2337V11H75.6437ZM79.2472 11V0.2H80.8372V11H79.2472ZM86.3307 11.18C85.6007 11.18 84.9507 11.02 84.3807 10.7C83.8207 10.37 83.3807 9.915 83.0607 9.335C82.7407 8.755 82.5807 8.08 82.5807 7.31C82.5807 6.53 82.7357 5.845 83.0457 5.255C83.3657 4.665 83.8057 4.205 84.3657 3.875C84.9357 3.545 85.5957 3.38 86.3457 3.38C87.0757 3.38 87.7107 3.545 88.2507 3.875C88.7907 4.195 89.2107 4.625 89.5107 5.165C89.8107 5.705 89.9607 6.3 89.9607 6.95C89.9607 7.05 89.9557 7.16 89.9457 7.28C89.9457 7.39 89.9407 7.515 89.9307 7.655H84.1407C84.1907 8.375 84.4257 8.925 84.8457 9.305C85.2757 9.675 85.7707 9.86 86.3307 9.86C86.7807 9.86 87.1557 9.76 87.4557 9.56C87.7657 9.35 87.9957 9.07 88.1457 8.72H89.7357C89.5357 9.42 89.1357 10.005 88.5357 10.475C87.9457 10.945 87.2107 11.18 86.3307 11.18ZM86.3307 4.685C85.8007 4.685 85.3307 4.845 84.9207 5.165C84.5107 5.475 84.2607 5.945 84.1707 6.575H88.3707C88.3407 5.995 88.1357 5.535 87.7557 5.195C87.3757 4.855 86.9007 4.685 86.3307 4.685ZM94.1305 11.18C93.5005 11.18 92.9805 11.075 92.5705 10.865C92.1605 10.655 91.8555 10.38 91.6555 10.04C91.4555 9.69 91.3555 9.31 91.3555 8.9C91.3555 8.18 91.6355 7.61 92.1955 7.19C92.7555 6.77 93.5555 6.56 94.5955 6.56H96.5455V6.425C96.5455 5.845 96.3855 5.41 96.0655 5.12C95.7555 4.83 95.3505 4.685 94.8505 4.685C94.4105 4.685 94.0255 4.795 93.6955 5.015C93.3755 5.225 93.1805 5.54 93.1105 5.96H91.5205C91.5705 5.42 91.7505 4.96 92.0605 4.58C92.3805 4.19 92.7805 3.895 93.2605 3.695C93.7505 3.485 94.2855 3.38 94.8655 3.38C95.9055 3.38 96.7105 3.655 97.2805 4.205C97.8505 4.745 98.1355 5.485 98.1355 6.425V11H96.7555L96.6205 9.725C96.4105 10.135 96.1055 10.48 95.7055 10.76C95.3055 11.04 94.7805 11.18 94.1305 11.18ZM94.4455 9.89C94.8755 9.89 95.2355 9.79 95.5255 9.59C95.8255 9.38 96.0555 9.105 96.2155 8.765C96.3855 8.425 96.4905 8.05 96.5305 7.64H94.7605C94.1305 7.64 93.6805 7.75 93.4105 7.97C93.1505 8.19 93.0205 8.465 93.0205 8.795C93.0205 9.135 93.1455 9.405 93.3955 9.605C93.6555 9.795 94.0055 9.89 94.4455 9.89ZM103.034 8.72C102.644 8.72 102.284 8.675 101.954 8.585L101.309 9.215C101.419 9.285 101.554 9.345 101.714 9.395C101.874 9.445 102.099 9.49 102.389 9.53C102.679 9.57 103.074 9.61 103.574 9.65C104.564 9.74 105.279 9.98 105.719 10.37C106.159 10.75 106.379 11.26 106.379 11.9C106.379 12.34 106.259 12.755 106.019 13.145C105.789 13.545 105.424 13.865 104.924 14.105C104.434 14.355 103.804 14.48 103.034 14.48C101.994 14.48 101.149 14.28 100.499 13.88C99.8594 13.49 99.5394 12.895 99.5394 12.095C99.5394 11.785 99.6194 11.475 99.7794 11.165C99.9494 10.865 100.214 10.58 100.574 10.31C100.364 10.22 100.179 10.125 100.019 10.025C99.8694 9.915 99.7344 9.805 99.6144 9.695V9.335L100.904 8.015C100.324 7.515 100.034 6.86 100.034 6.05C100.034 5.56 100.149 5.115 100.379 4.715C100.619 4.305 100.964 3.98 101.414 3.74C101.864 3.5 102.404 3.38 103.034 3.38C103.454 3.38 103.844 3.44 104.204 3.56H106.979V4.61L105.659 4.685C105.899 5.095 106.019 5.55 106.019 6.05C106.019 6.55 105.899 7 105.659 7.4C105.429 7.8 105.089 8.12 104.639 8.36C104.199 8.6 103.664 8.72 103.034 8.72ZM103.034 7.475C103.494 7.475 103.864 7.355 104.144 7.115C104.434 6.865 104.579 6.515 104.579 6.065C104.579 5.605 104.434 5.255 104.144 5.015C103.864 4.775 103.494 4.655 103.034 4.655C102.564 4.655 102.184 4.775 101.894 5.015C101.614 5.255 101.474 5.605 101.474 6.065C101.474 6.515 101.614 6.865 101.894 7.115C102.184 7.355 102.564 7.475 103.034 7.475ZM101.039 11.945C101.039 12.375 101.229 12.695 101.609 12.905C101.989 13.125 102.464 13.235 103.034 13.235C103.584 13.235 104.029 13.115 104.369 12.875C104.709 12.645 104.879 12.335 104.879 11.945C104.879 11.655 104.764 11.405 104.534 11.195C104.304 10.995 103.869 10.87 103.229 10.82C102.749 10.79 102.324 10.745 101.954 10.685C101.604 10.875 101.364 11.08 101.234 11.3C101.104 11.52 101.039 11.735 101.039 11.945ZM111.143 11.18C110.243 11.18 109.533 10.9 109.013 10.34C108.503 9.78 108.248 8.945 108.248 7.835V3.56H109.838V7.67C109.838 9.11 110.428 9.83 111.608 9.83C112.198 9.83 112.683 9.62 113.063 9.2C113.443 8.78 113.633 8.18 113.633 7.4V3.56H115.223V11H113.813L113.693 9.695C113.463 10.155 113.123 10.52 112.673 10.79C112.233 11.05 111.723 11.18 111.143 11.18ZM120.725 11.18C119.995 11.18 119.345 11.02 118.775 10.7C118.215 10.37 117.775 9.915 117.455 9.335C117.135 8.755 116.975 8.08 116.975 7.31C116.975 6.53 117.13 5.845 117.44 5.255C117.76 4.665 118.2 4.205 118.76 3.875C119.33 3.545 119.99 3.38 120.74 3.38C121.47 3.38 122.105 3.545 122.645 3.875C123.185 4.195 123.605 4.625 123.905 5.165C124.205 5.705 124.355 6.3 124.355 6.95C124.355 7.05 124.35 7.16 124.34 7.28C124.34 7.39 124.335 7.515 124.325 7.655H118.535C118.585 8.375 118.82 8.925 119.24 9.305C119.67 9.675 120.165 9.86 120.725 9.86C121.175 9.86 121.55 9.76 121.85 9.56C122.16 9.35 122.39 9.07 122.54 8.72H124.13C123.93 9.42 123.53 10.005 122.93 10.475C122.34 10.945 121.605 11.18 120.725 11.18ZM120.725 4.685C120.195 4.685 119.725 4.845 119.315 5.165C118.905 5.475 118.655 5.945 118.565 6.575H122.765C122.735 5.995 122.53 5.535 122.15 5.195C121.77 4.855 121.295 4.685 120.725 4.685Z"
                  fill="white"
                />
              </svg>
            </button>
          </form>
        </div>
      </Header>

      <div className="grid grid-cols-2 px-4 py-6 gap-x-10">
        <div>
          <article>
            <h1 className="text-3xl font-normal	mb-4">Welcome {firstName}!</h1>
            <p className="font-normal">Waiting room settings</p>
            <p className="text-sm text-gray-500 max-w-xs">
              The patient can learn more about you while waiting for their
              number.
            </p>
          </article>

          <Formik
            initialValues={{
              orgName: "",
              greetings: "",
              about: "",
              link: "",
              allLinks: [],
              images: [],
            }}
            validationSchema={waitingRoomSchema}
            onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
              <Form className="bg-white mt-4 grid gap-y-5 py-5 pl-5 pr-12 rounded-lg">
                <div className="grid gap-y-2">
                  <label
                    htmlFor="orgName"
                    className="font-dm-sans text-sm text-grey-secondary font-medium">
                    Organization Name
                  </label>
                  <Field
                    name="orgName"
                    id="orgName"
                    type="text"
                    placeholder="Organization Name"
                    className="rounded-lg"
                  />
                  <ErrorMessage name="orgName">
                    {(msg) => <FieldError message={msg} />}
                  </ErrorMessage>
                </div>

                <div className="grid gap-y-2">
                  <label
                    htmlFor="greetings"
                    className="font-dm-sans text-sm text-grey-secondary font-medium">
                    Greetings
                  </label>
                  <Field
                    name="greetings"
                    id="greetings"
                    type="text"
                    placeholder="Greetings"
                    className="rounded-lg"
                  />
                  <ErrorMessage name="greetings">
                    {(msg) => <FieldError message={msg} />}
                  </ErrorMessage>
                </div>

                <div className="grid gap-y-2">
                  <label
                    htmlFor="about"
                    className="font-dm-sans text-sm text-grey-secondary font-medium">
                    About doctor/organization
                  </label>
                  <Field
                    style={{ resize: "none" }}
                    name="about"
                    id="about"
                    as="textarea"
                    placeholder="Write here..."
                    cols={30}
                    rows={4}
                    maxLength={200}
                    className="rounded-md"
                  />
                  <ErrorMessage name="about">
                    {(msg) => <FieldError message={msg} />}
                  </ErrorMessage>
                </div>

                <div className="grid gap-y-2">
                  <p className="font-dm-sans text-sm text-grey-secondary font-medium">
                    Gallery
                  </p>

                  <div className="grid grid-cols-3 gap-x-1 gap-y-1 ">
                    {values.images.map(({ id, src }) => {
                      return (
                        <div key={id} className="relative">
                          <img className="object-cover h-40" src={src} alt="" />
                          <button
                            type="button"
                            className="absolute top-0 right-0 bg-white"
                            onClick={(e) => {
                              e.preventDefault();
                              removeImage(id, values, setFieldValue);
                            }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="w-6 h-6">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                      );
                    })}
                  </div>

                  <label className="flex justify-center max-w-2xl px-6 py-8 pb-6 border-2 bg-blue-primary-light border-gray-300 border-dashed rounded-md cursor-pointer">
                    <div className="space-y-1 text-center">
                      <svg
                        className="w-8 h-8 mx-auto text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true">
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <div className="flex text-sm font-medium text-gray-400 ">
                        <span>Drop here or Browse</span>
                        <input
                          type="file"
                          className="sr-only bg-primary"
                          multiple={true}
                          onChange={(e) => encodeFile(e, setFieldValue, values)}
                          accept="image/jpeg, image/jpg, image/png"
                        />
                      </div>
                    </div>
                  </label>

                  <p className="font-dm-sans text-sm text-grey-secondary font-medium italic">
                    Multiple uplaods available. Max limit 200mb.
                  </p>
                </div>

                <div className="grid gap-y-2">
                  <label
                    htmlFor="link"
                    className="font-dm-sans text-sm text-grey-secondary font-medium">
                    Important Links
                  </label>
                  <Field
                    id="link"
                    name="link"
                    type="text"
                    placeholder="Link"
                    className="rounded-md"
                  />
                  <ErrorMessage name="link">
                    {(msg) => <FieldError message={msg} />}
                  </ErrorMessage>
                  <button
                    type="button"
                    className="justify-self-start text-primary mt-3 mb-2"
                    onClick={() => handleAddLinks(values, setFieldValue)}>
                    + Add
                  </button>

                  <div className="grid text-grey-secondary gap-y-2">
                    {values.allLinks.map(({ id, href }) => {
                      return (
                        <div key={id}>
                          <a
                            className="border-grey-secondary border-2 border-solid rounded-md p-2 flex justify-between"
                            href={href}
                            target="_blank"
                            rel="noreferrer">
                            {href}
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="flex gap-x-5">
                  <button
                    className="border-primary border-2 border-solid py-3 px-9 rounded-md text-primary"
                    type="reset">
                    Clear
                  </button>
                  <button
                    className="border-primary border-2 border-solid py-3 px-9 rounded-md text-white bg-primary"
                    type="submit">
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        {/* right side */}
        <div>
          <div className="flex items-end pb-3" style={{ height: "132px" }}>
            <p>Patient's waiting room view</p>
          </div>
          {!displayVals.orgName ? (
            <div
              style={{ height: "calc(100% - 138px)" }}
              className={`border-2 border-dashed border-primary rounded-lg`}></div>
          ) : (
            <div
              style={{ height: "calc(100% - 138px)" }}
              className="bg-white px-10 py-6 rounded-lg">
              <div>
                <h1 className="text-3xl capitalize">{displayVals.orgName}</h1>
                <h1 className="text-3xl">Welcomes you</h1>
                <div className="w-9 h-1 bg-primary my-6"></div>
              </div>

              <div>
                <h1 className="text-lg mb-4">{displayVals.greetings}</h1>
                <p className="text-sm text-grey-secondary2">
                  {displayVals.about}
                </p>
                <div className="w-9 h-1 bg-primary my-6"></div>
              </div>

              {displayVals.images.length > 0 && (
                <div>
                  <h1 className="text-lg mb-4">Gallery</h1>
                  <div className="grid grid-cols-3 gap-1">
                    {displayVals.images.map(({ id, src }) => {
                      return (
                        <div key={id}>
                          <img
                            className="w-48 h-40 object-cover"
                            src={src}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="w-9 h-1 bg-primary my-6"></div>
                </div>
              )}

              <div>
                <h1 className="mb-4 text-lg">
                  Check out these links while you wait.
                </h1>
                {displayVals.allLinks.map(({ id, href }) => {
                  return (
                    <div
                      key={id}
                      className="flex items-center gap-x-2 border-b-2 border-grey-secondary pb-2 mb-1">
                      <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text-primary">
                        {href}
                      </a>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10.6689 6.276L4.93095 12.014L3.98828 11.0713L9.72561 5.33333H4.66895V4H12.0023V11.3333H10.6689V6.276Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WaitingRoom;
